import React, { Component } from 'react';

import {connect} from "react-redux";
import Header from "./components/header";
import Footer from "./components/footer";
import { withRouter } from "react-router-dom";
import PageListen from "./components/pagelisten";
import * as wActs from "./actions/website-actions";
import * as sActs from "./actions/server-actions";
import {Helmet} from "react-helmet";
import { IntlProvider } from 'react-intl';
import HtmlSection from "./components/htmlsection";
import HomeHeader from "./components/homeheader";
import BreadCrumbs from "./components/breadcrumbs";
import Warnings from "./components/warning";
import SsrBanner from "./components/ssrbanner";
import SwBanner from "./components/swbanner";
import BuyAdBanner from "./components/buyadbanner"
import BannersLoader from "./components/banners";
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      pageType: props.pageType,
      BannersLoader: null
    };
  }

  componentDidMount() {
    if(typeof window !== "undefined") {
      if(this.state.BannersLoader==null) {
        this.BannersLoader = new BannersLoader({ Interval: 100, TriggerMS: 100, ImpressionsMS: 3000, Request: this.props.Website.Request, UserId: this.props.Website.User.UserId });
        this.setState({BannersLoader: this.BannersLoader});
        this.props.dispatch({type: "SET-BANNERS-LOADER", payload: this.BannersLoader});
      }
      if(sActs.getServerCookie(this.props.Website.ServerParams.Cookies,"anon") === null) {
        wActs.setCookie("anon", this.props.Website.Request.AnonymousId, { path: "/", maxAge: 31557600, domain: "." + wActs.getSubdomain(window.location.hostname) });
      }
    }
    if(!this.isPaged()) {
      this.H1TextBlock.innerHTML = this.props.Website.Page.H1TextBlock;
    }
  }

  componentDidUpdate() {

  }

  handleScroll(e) {

  }

  getFilterTitle(nme) {
    if(nme=="ournetwork") return this.getTranslation("page.advertise.ournetwork");
    if(nme=="other") return this.getTranslation("menu.other");
    return nme;
  }


  getTitle(title) {
    let page = title;
    let furl = "https://www.fake.com/"
    if(typeof window === "undefined") {
      furl = furl + this.props.Website.ServerParams.Query;
    } else {
      furl = window.location.href;
    }
    if(wActs.getParameterByName("page",furl,"") !== "") {
      page = this.getTranslation("page.pagex").replace("{{pagenumber}}", wActs.getParameterByName("page", furl, "")) + " - " + page;
    }
    let filter = wActs.getParameterByName("filter",furl,"");
    if(!wActs.isNullOrEmpty(filter)) {
      page = this.getFilterTitle(filter) + " - " + page;
    }
    return page;
  }


  smallWidth() {
    if(typeof window !== "undefined") {
      if(window.innerWidth < 767) {
        return true;
      }
    } else {
      return false;
    }
    return false;
  }

  getTranslation(key) {
    return this.props.Website.Translations[key];
  }
  isPaged() {
    let qry = "http://www.fakeurl.com/"
    if(typeof document === "undefined") {
      qry += this.props.Website.ServerParams.Query;
    } else {
      qry += document.location.search;
    }
    return wActs.getParameterByName("page",qry,"") !== ""; //Paged Page :)
  }

  hasPage() {
    let pge = "";
    if(typeof window !== "undefined") {
      pge = wActs.getParameterByName("page",window.location.href,"");
    } else {
      pge = wActs.getParameterByName("page",`https://www.d.com${this.props.Website.ServerParams.Query}`,"");
    }
    return !wActs.isNullOrEmpty(pge);
  }


  render() {
    if(!this.props.SiteLoaded) {
      return (
      <div id={"loadingDiv"}>
        <img src="/imgs/loader.gif" width="100" height="100" alt={"Loading"}/>
      </div>
      );
    }

    let xDef = typeof window === "undefined" ? wActs.stripCulturePath(this.props.Website.ServerParams.Path) : wActs.stripCulturePath(window.location.pathname);
    xDef = wActs.getCultPathByLang(this.props.Website, wActs.defaultLang(this.props.Website)) + xDef.substr(1);
    let mob = this.props.Website.Device.IsMobileDevice;

    let tmp = this.props.Template;
    let acc = "";
    if(!wActs.isNullOrUndefined(tmp)) {
      if(!wActs.isNullOrUndefined(tmp.Country) && !wActs.isNullOrEmpty(tmp.Country.Code)) {
        acc=tmp.Country.Code;
      }
    }
    let url = "";
    if(typeof window !== "undefined") {
      url = window.location.href;
    } else {
      url = "https://www.fakeurl.com/dude" + this.props.Website.ServerParams.Query;
    }
    let qcc = wActs.getParameterByName("country",url,"")
    if(!wActs.isNullOrEmpty(qcc)) { acc = qcc; }

    let burl = `https://${this.props.Website.Settings.Domain}/`;
    if(this.props.Website.ServerParams.Referer.toLowerCase().indexOf("stage")>-1 || this.props.Website.ServerParams.Referer.toLowerCase().indexOf("staging")>-1) {
      burl = "/";
    }
    let ihme = this.props.Website.Page.Name == "Home";
    let pge = this.hasPage();
    if(pge) {ihme=false} //Do Not Show On Pages Etheir The Privacy And Terms...
    let key = "home-200x100";
    if(!ihme) {
      key = "side-bar-200x100";
    }

    return (
      <div className="App" id={"mainApp"}>
        {this.props.Website.PageLoaded &&
        <Helmet>
          <title>{this.getTitle(this.props.Website.Page.Title)}</title>
          {!this.props.Website.Page.HideKeywords &&
          <meta name="keywords" content={this.props.Website.Page.Keywords} />
          }
          <meta name="description" content={this.props.Website.Page.Description} />
          {
            this.props.Website.Page.Properties.map((v,i) => {
              let cnt = v.Content;
              if(v.Name.indexOf(":title")>0) {
                cnt = this.getTitle(this.props.Website.Page.Title);
              }
              if(v.Name.startsWith("twitter:")) {
                return <meta key={"set-" + i} name={v.Name} content={cnt}/>;
              } else {
                return <meta key={"set-" + i} property={v.Name} content={cnt}/>;
              }
            })
          }
          {
            this.props.Website.Page.Icons.map((v,i) => {
              return <link key={"ico-" + i} rel={v.Rel} sizes={v.Sizes} type={v.Type} href={v.Href} />;
            })
          }
          {!wActs.isNullOrUndefined(this.props.Website.Page.References) &&
          this.props.Website.Page.References.filter((t) => { return t.Rel.toLowerCase() === "alternate" }).map((v, i) => {
            return <link key={"alt-" + i} rel={v.Rel} href={wActs.isNullOrEmpty(v.Href === "") ? "/" : v.Href} hrefLang={v.HrefLang == "rs" ? "sr" : v.HrefLang} />;
          })
          }
          {(!wActs.isNullOrUndefined(this.props.Website.Page.References) && this.props.Website.ServerParams.Path !== "/404") &&
          this.props.Website.Page.References.filter((t)=>{return t.Rel.toLowerCase() === "canonical"}).map((v,i) => {
            return <link key={"can-" + i} rel={v.Rel} href={v.Href} />;
          })
          }
          {this.props.Website.Page.NoIndex &&
          <meta name="robots" content="noindex"/>
          }
          <base href={burl}/>
        </Helmet>
        }
        <IntlProvider locale={this.props.Website.TranslationsLocal} defaultlocale={'en'} messages={this.props.Website.Translations} >
            <React.Fragment>
              <Header/>
              {typeof window !== "undefined" && <PageListen/>}
              <div className={`${this.props.PageType == "home" ? "front-page" : this.props.PageType == "support" ? "inner-page contact-page" : " inner-page form-page register-page"}`}>

                {this.props.PageType == "home" &&
                <HomeHeader/>
                }

                <BreadCrumbs/>

                <div className={`${this.props.PageType == "home" ? "content bg" : "container"}`}>
                  {this.props.children}
                </div>

                <div className="section bndtxt">
                  <div className="text">
                    {(this.props.PageType == "home" && !wActs.isNullOrEmpty(this.props.Website.Page.H1Text) && typeof window != "undefined") &&
                    <h1 dangerouslySetInnerHTML={{__html: this.props.Website.Page.H1Text.replace("<br/>","")}}></h1>
                    }
                    {(this.props.Website.Page.Template.Name=="LinksList" && !wActs.isNullOrEmpty(this.props.Website.Page.H1Text) && typeof window == "undefined") &&
                    <h1 dangerouslySetInnerHTML={{__html: this.props.Website.Page.H1Text.replace("<br/>","")}}></h1>
                    }

                    {!this.isPaged() &&
                    <p style={{maxWidth: "100%"}} ref={(ref) => {this.H1TextBlock = ref}} dangerouslySetInnerHTML={{__html: this.props.Website.Page.H1TextBlock}}></p>
                    }
                  </div>
                  <div className="clear"></div>
                  {this.props.PageType !== "home" &&
                    <div className="flex-center-wrap" style={{margin: "30px 40px"}}>
                      <SwBanner BannersLoader={this.state.BannersLoader} apiAnonId={this.props.Website.Request.AnonymousId} tagText={this.props.Website.Settings.HtmlSections['Adserver-200x200-featured']}  className="footer-banners" country={acc} >
                        <BuyAdBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} />
                      </SwBanner>
                      <SwBanner BannersLoader={this.state.BannersLoader} apiAnonId={this.props.Website.Request.AnonymousId} tagText={this.props.Website.Settings.HtmlSections['Adserver-200x200-bottombar']}  className="footer-banners" country={acc} >
                        <BuyAdBanner size="200x200" textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} />
                      </SwBanner>
                    </div>
                  }

                  <div className={"flex-center"} style={{marginBottom: "30px"}}>
                    <SsrBanner ZoneId={key} AdsHereCount={1} className={"footer-banners"} CountryCode={acc} IsHome={ihme}>
                      <BuyAdBanner size={"200x100"} textButton={this.getTranslation("page.advertise.advertisehere")} textTop={this.getTranslation("page.advertise.getxtimesmorevisitors")} textBottom={this.getTranslation("page.advertise.buyabanneraddtoday")} hideBottom={true}/>
                    </SsrBanner>
                  </div>

                </div>

              </div>
              <Footer/>
              <Warnings/>
              <HtmlSection Id="Onesignal"/>
            </React.Fragment>
        </IntlProvider>
      </div>
    );
  }




}

function exportWithRouter() {
  if (typeof window !== "undefined") {
    return withRouter(connect(mapStateToProps)(App));
  } else {
    return connect(mapStateToProps)(App);
  }
}



const mapStateToProps = (state) => {
  return {
    SiteLoaded: state.Website.Loaded,
    Menu: state.Website.Menu,
    Settings: state.Website.Settings,
    Website: state.Website,
    PageMenu: state.Website.Page.Menu,
    Template: state.Website.Page.Template,
    PageType: state.Website.PageType
  };
};



export default exportWithRouter(); //Added This To Support Pageless Once SSR Is Done.. Only Works Client Withrouter, And Without SSR
